import React, { useLayoutEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { chunk } from "lodash";
import Marquee from "react-marquee-slider";

const colors = { 1: "#7fd4d3", 2: "#9bdddc", 3: "#ceeeee", 4: "#e7f7f7" };

const Row = ({ items, style = {}, velocity }) => {
  const ref = useRef();
  const [width, setWidth] = useState(0);
  const speed = width / ((velocity || 10) * 1000);

  useLayoutEffect(() => {
    let tempWidth = 0;
    for (let index = 0; index < ref.current.firstChild.children.length; index++) {
      const element = ref.current.firstChild.children[index];
      tempWidth += element.offsetWidth;
    }
    setWidth(tempWidth);
  }, []);

  return (
    <div className="marquee" ref={ref}>
      <Marquee velocity={speed}>
        {items.map(({ text, value }, index) => (
          <div className="marqueeItem" key={index} style={{ background: colors[value] || colors[0] }}>
            <p className="text-white">{text}</p>
          </div>
        ))}
      </Marquee>
    </div>
  );
};

const shuffleArray = arr => {
  const newArr = arr.slice();
  for (let i = newArr.length - 1; i > 0; i--) {
    const rand = Math.floor(Math.random() * (i + 1));
    [newArr[i], newArr[rand]] = [newArr[rand], newArr[i]];
  }
  return newArr;
};

const getChunks = (arr, num) => {
  const newArr = arr.slice();
  newArr.length % 2 && newArr.push(newArr[0]);
  const shuffledArr = shuffleArray([...newArr, ...newArr, ...newArr]);
  const chunks = chunk(shuffledArr, Math.round(shuffledArr.length / num));

  return chunks;
};

const MarqueeComponent = ({ content }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });
  const chunks = getChunks(
    content.items.filter(({ text }) => text?.length),
    isMobile ? 3 : 2
  );

  return (
    <div id="marqueeWrapper" className="full-width">
      <p className="title">{content.title}</p>
      {chunks.map((element, index) => (
        <Row key={index} items={element} velocity={isMobile ? content.velocityMobile : content.velocity} />
      ))}
    </div>
  );
};

export default MarqueeComponent;
